import { Box, getColor, useTheme } from "@powerledger/ui-component-lib";
import ReactTooltip from "react-tooltip";

export const GenericTooltip = () => {
  const { theme } = useTheme();

  return (
    <ReactTooltip
      backgroundColor={getColor(theme, "shadow")}
      getContent={(tooltipContent) => <Box sx={{ fontSize: 1, maxWidth: 300, color: "text" }}>{tooltipContent}</Box>}
    />
  );
};
